// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"ccf5e3996c72d611ee9c","293":"02d6b44735a8ba947d62"}[chunkId] + ".js";
};